import { useContext, useEffect, useState } from 'react';
import { WelletContext } from '../../../context/WelletContext';
import { CircleSpinner } from 'react-spinners-kit';
import { useDispatch, useSelector } from 'react-redux';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { format } from 'date-fns';
import { convertTime12to24, getDatePerformance, getLocale } from '../../../helpers/dates';
import { useTranslation } from 'react-i18next';
import useForm from '../../../helpers/useForm';
import ContentApp from '../../../components/ContentApp';
import ButtonProccessing from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import ReservationCheckCustomerInfo from '../../../components/ReservationCheck/ReservationCheckCustomerInfo/ReservationCheckCustomerInfo';
import CustomerSpecialRequest from '../../../components/ReservationCheck/CustomerSpecialRequest/CustomerSpecialRequest';
import Header from '../../../components/Common/Header/Header';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import styles from './reservationCheck.module.css';
import Summary from '../../../components/ReservationCheck/Summary/Summary';
import SummaryProducts from '../../../components/ReservationCheck/Summary/SummaryProducts';
import SummaryBox from '../../../components/ReservationCheck/Summary/SummaryBox';
import ProductPerformanceSelector from '../../../components/PerformanceSelector/PerformanceSelector';
import { getQueryString } from '../../../helpers/url';
import Money from '../../../components/Common/Money/Money';
import '../../../components/ReservationDetail/reservation-details.css';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import InputFormBorder from '../../../components/Common/InputFormBorder/InputFormBorder';
import { fetchReservation } from '../../../helpers/reservation';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import ContentBottom from '../../../components/ContentBottom';
import OccasionSelectorButton from '../../../components/ReservationCheck/OccasionSelectorButton/OccasionSelectorButton';
import { lockScheduleDelete } from '../../../services/reservations/reservationsService';
import { clearAvailableTime } from '../../../actions/timerActions';
import ReservationTimer from '../../../components/ReservationTimer/ReservationTimer';

const ReservationCheck = ({ history }) => {
  const ButtonStatus = {
    Normal: 'NORMAL',
    InProgress: 'INPROGRESS',
    ProgressFinished: 'FINISHED',
    Error: 'ERROR',
  };
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const refReservationId = getQueryString('refReservationId');

  const dispatch = useDispatch();
  const user = useSelector((state) => state.associates.user);
  const reservation = useSelector((state) => state.reservation);
  const hasProducts = reservation.products?.length > 0;
  const [paxs, setPaxs] = useState(reservation.paxs);
  const countryCode = useSelector((state) => state.app.currentMarket.countryCode);
  const [externalPlaftormInfo, setExternalPlaftormInfo] = useState(null);
  const language = useSelector((state) => state.app.language);
  const [selectedOccasion, setSelectedOccasion] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [open, setOpen] = useState(true);
  const [error, setError] = useState(null);
  const rawPlatform = getQueryString('platform');
  const availableTime = useSelector((state) => state?.timerLock?.availableTime);
  const platform = rawPlatform === 'true' ? true : rawPlatform === 'false' ? false : rawPlatform;
  const [loading, setLoading] = useState(true);
  const [reservationInfo, setReservationInfo] = useState(null);
  const [reservationDate, setReservationDate] = useState(null);
  const currency = useSelector((state) => state.currency.selected);
  const isCustomer = user?.roles?.includes('customer');
  const [initialNoAvailabilityError, setInitialNoAvailabilityError] = useState(null);
  const locale = getLocale(language);

  //Areas vip
  const [intervals, setIntervals] = useState([]);
  const [loadingSchedule, setLoadingSchedule] = useState(true);
  const [selectedPerformance, setSelectedPerformance] = useState(null);
  const requiredPerformance = ['area', 'group'];

  const handleSelectOccasion = (value) => {
    setSelectedOccasion(value);
  };

  const handleBack = () => {
    const reservationToken = getQueryString('reservationToken');

    if (platform && reservationToken && reservation.date) {
      const payload = {
        reservationDateLocalTime: new Date(reservation.date + 'T00:00:00'),
        reservationType: 'RESTAURANT',
        showId: reservation.showId,
        token: reservationToken,
        paxs,
        attribute: reservation.attribute,
      };

      lockScheduleDelete(welletContext, payload);
    }

    dispatch(clearAvailableTime());
    history.goBack();
  };

  function validate(values) {
    let errors = {};

    if (!isCustomer) errors = validateCustomerInfo(values);

    if (requiredPerformance.includes(reservation.reservationType) && !selectedPerformance) {
      errors.performance = t('selectArrivalTime');
    }

    return errors;
  }
  const getExternalPlatform = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/${reservation.showId}/external-plaftorm/config?reservationType=RESTAURANT`,
      );
      setExternalPlaftormInfo(result.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (platform !== null) {
      getExternalPlatform();
    }
  }, []);
  function validateCustomerInfo(values) {
    const errors = {};

    if (!values.customerName) {
      errors.customerName = t('nameError.EMPTY_NAME');
    } else if (/\d/.test(values.customerName)) {
      errors.customerName = t('nameError.NOT_NUMBERS');
    }

    if (!values.email) {
      errors.email = t('emailError.EMPTY_EMAIL');
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }

    if (!values.customerLastname) {
      errors.customerLastname = t('nameError.EMPTY_LASTNAME');
    } else if (/\d/.test(values.customerLastname)) {
      errors.customerLastname = t('nameError.NOT_NUMBERS');
    }
    if (!values.phone) {
      errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
      setPhoneError(errors.phone);
    } else {
      setPhoneError('');
    }

    if (values.phone && !isValidPhoneNumber(values.phone)) {
      errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
      setPhoneError(errors.phone);
    }

    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }

    return errors;
  }

  const sendForm = async () => {
    setBtnStatus(ButtonStatus.InProgress);
    let reservationLocalTime = '';
    let availabilityRefId = '';

    if (selectedPerformance != null) {
      reservationLocalTime = reservation.date + 'T' + selectedPerformance;
      const reservationTimeInt = new Date(reservationLocalTime).getTime();

      availabilityRefId = intervals.find(
        (interval) => interval.time.getTime() === reservationTimeInt,
      )?.availabilityRefId;
    } else {
      reservationLocalTime = getDatePerformance(reservation.date, reservation.performance);
      availabilityRefId = reservation.availabilityRefId;
    }

    try {
      let url = '/reservation/GenerateReservation';
      if (reservationInfo && reservationInfo.parentReservationReferenceCode) {
        url = '/reservation/modifyreservation';
      }

      const reservationToken = getQueryString('reservationToken');

      const requestBody = {
        showId: reservation.showId,
        paxs: paxs,
        customer: {
          firstName: values.customerName,
          lastName: values.customerLastname,
          phone: values.phone,
          email: values.email,
        },
        customerLanguage: values.language,
        email: values.email ?? '',
        comments: values.comments ?? '',
        OccasionId: selectedOccasion ?? null,
        countryCode: values.countryCode ?? 'MX',
        reservationDateLocalTime: reservationLocalTime,
        totalAmount: reservationInfo?.totalAmount ?? null,
        products: reservation.products ?? null,
        oldReservationId: refReservationId,
        eventName: values.eventName,
        availabilityRefId: availabilityRefId,
        language: null,
        attribute: reservation.attribute,
      };
      if (reservationToken) {
        requestBody.availabilityRefId = reservationToken;
      }

      const result = await welletContext.apis.tickets.put(url, requestBody);

      setBtnStatus(ButtonStatus.ProgressFinished);
      setTimeout(() => {
        history.push(
          `/reservation-success?reservationType=${result.data.reservationType}&status=${result.data.status}`,
        );
      }, 1500);
    } catch (error) {
      setBtnStatus(ButtonStatus.Error);
      let errorMessage;

      switch (error.response.data.errorType) {
        case 'GENERIC_ERROR':
          errorMessage = t('reservationError.GENERIC_ERROR');
          break;
        case 'SHOW_NOT_FOUND':
          errorMessage = t('reservationError.SHOW_NOT_FOUND');
          break;
        case 'SCHEDULE_SOLD_OUT':
          errorMessage = t('reservationError.SCHEDULE_SOLD_OUT');
          break;
        case 'INVALID_RESERVATION_DATE':
          errorMessage = t('reservationError.INVALID_RESERVATION_DATE');
          break;
        case 'NO_AVAILABILITY':
          errorMessage = t('reservationError.NO_AVAILABILITY');
          break;
        case 'DUPLICATE_RESERVATION':
          errorMessage = t('reservationError.DUPLICATE_RESERVATION');
          break;
        case 'PURCHASE_RULE_NOT_SATISFIED':
          errorMessage = t('reservationError.PURCHASE_RULE_NOT_SATISFIED');
          break;
        default:
          errorMessage = t('reservationError.GENERIC_ERROR');
      }

      setError(errorMessage);
    }
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);
  //const alignedDate = date && alignTimezone(date);
  //const adjustedDate = shouldAddDay ? addDays(alignedDate, 1) : alignedDate;

  const getReservation = async () => {
    setLoading(true);
    let reservationPreview = null;
    const result = await fetchReservation({
      welletContext,
      reservation,
      language,
      refReservationId,
    });
    if (result.success) {
      const data = result.data;
      reservationPreview = data;
      setReservationInfo(data);
      setInitialValues(data);
      setPaxs(data.paxs);
      setReservationDate(new Date(reservation.date + 'T00:00:00'));
    } else {
      console.error(result.error);
    }
    setLoading(false);
    return reservationPreview;
  };

  const setSchedule = (availability) => {
    try {
      if (availability.schedules.length === 0) {
        setIntervals([]);
        setLoadingSchedule(false);
        return;
      }

      const formattedTimes = availability.schedules.map((time) => {
        const time24 = new Date(reservation.date + 'T' + convertTime12to24(time.timeStart));

        if (time.timeMinutesStart >= 0 && time.timeMinutesStart <= 360)
          time24.setDate(time24.getDate() + 1);

        return { time24, soldOut: time.isSoldOut, availabilityRefId: time.availabilityRefId };
      });
      formattedTimes.sort();

      const allIntervals = formattedTimes.map(({ time24, soldOut, availabilityRefId }) => ({
        time: time24,
        soldOut,
        availabilityRefId,
      }));

      setIntervals(allIntervals);
    } catch (error) {
      console.error(error);
    }
  };

  const setInitialValues = (reservation) => {
    handleChange(null, 'customerName', reservation.customerName);
    handleChange(null, 'phone', reservation.customerPhone);
  };

  const getReservationAndSchedule = async () => {
    setLoadingSchedule(true);
    const reservation = await getReservation();
    if (reservation.isAvailable === false) {
      setInitialNoAvailabilityError(t('reservationError.NO_AVAILABILITY'));
    } else {
      setSchedule(reservation.availability);
    }
    setLoadingSchedule(false);
  };

  useEffect(() => {
    handleChange(null, 'language', language);

    if (reservation.date && reservation.performance) {
      setReservationDate(new Date(reservation.date + 'T' + reservation.performance));
    }

    if (hasProducts) {
      getReservationAndSchedule();
    }
  }, []);

  return (hasProducts && loading) || reservationDate === null ? (
    <div className='loaderDiv'>
      <CircleSpinner
        className='spinner-app mx-auto'
        style={{ margin: 'auto' }}
        size={40}
        color='var(--color-font-primary)'
      />
    </div>
  ) : (
    <>
      <Header onClick={handleBack} />
      <ContentApp menu={true} classes='pb-0'>
        <div className={`order-details ${styles.reservation}`}>
          {initialNoAvailabilityError ? (
            <>
              <ErrorBox title={initialNoAvailabilityError} />
              <div className='mt-4 text-center text-primary' onClick={() => history.goBack()}>
                {t('reschedule')}
              </div>
            </>
          ) : (
            <>
              <EventHeader
                eventImg={reservationInfo?.show?.logoImageUrl || reservation.imageUrl}
                eventName={reservationInfo?.show?.name || reservation.showName}
                eventDescription={reservationInfo?.show?.city || reservation.showName}
                eventDate={reservationDate}
                paxs={
                  t('person', { count: reservationInfo?.paxs || reservation.paxs }) +
                  ` - ${format(reservationDate, 'h:mm aa')}`
                }
              />

              {availableTime && (
                <div className='mt-3'>
                  <ReservationTimer initialSeconds={availableTime} />
                </div>
              )}
              {reservationInfo ? (
                <>
                  <div className={styles.paymentSection}>
                    <SummaryProducts reservationInfo={reservationInfo} />
                    {reservationInfo.consumptionAmount > 0 ? (
                      <div className={`${styles.consumption} text-center mt-4`}>
                        {t('consumptionIncluded', {
                          consumption: '$' + reservationInfo?.consumptionAmount,
                        })}
                      </div>
                    ) : (
                      <div style={{ borderTop: '1px dashed #fff', marginTop: '1.5rem' }}></div>
                    )}
                  </div>
                  <div className={`border-none ` + styles.paymentSection}>
                    <Summary reservation={reservationInfo} />
                  </div>
                </>
              ) : null}

              {reservationInfo && (
                <>
                  {reservationInfo.paymentDetails && reservationInfo.paymentDetails.length > 0 ? (
                    <div className={styles.paymentSection} style={{ borderTop: '1px dashed #fff' }}>
                      <div className='bold'>{t('paymentsMade')}</div>
                      {reservationInfo.paymentDetails.map((payment) => (
                        <div className='row mt-3' key={payment.chargeId}>
                          <div className='col'>
                            <div className='fw-bold font-small'>
                              {t('payment')} #{payment.chargeId}
                            </div>
                            <div className='text-secondary font-tiny mt-1'>
                              <div>
                                <span className='text-capitalize'>{payment.brand}</span>
                                (xxxx xxxx xxxx {payment.last4})
                              </div>
                              <div>
                                {format(new Date(payment.paymentLocalDate), 'PPP hh:mm', {
                                  locale,
                                })}
                              </div>
                            </div>
                          </div>
                          <div className={`col-auto ${styles.paymentAmount}`}>
                            -<Money value={payment.amount} lowDecimals={true} />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : null}
                  {reservationInfo?.remainingDepositAmount > 0 &&
                  reservationInfo.parentReservationReferenceCode ? (
                    <div className={styles.paymentSection} style={{ borderTop: '1px dashed #fff' }}>
                      <div className='row font-normal '>
                        <div className='col bold pr-0'>{t('remainingBalance')}:</div>
                        <div className='col-auto bold'>
                          <Money
                            value={reservationInfo?.remainingDepositAmount}
                            symbolSize='14px'
                            decimal={false}
                            lowDecimals={true}
                          />
                        </div>
                      </div>
                      <div className='font-small text-secondary mt-4 px-3 text-center'>
                        {t('remainingBalanceText')}
                      </div>
                    </div>
                  ) : null}
                </>
              )}

              {!isCustomer ? (
                reservationInfo?.customerName ? (
                  <div className={styles.paymentSection}>
                    <div className='text-secondary text-medium fw-semibold'>
                      {t('bookingHolder')}
                    </div>
                    <div className='font-normal bold mt-1'>{reservationInfo.customerName}</div>
                  </div>
                ) : (
                  <div className='mt-4'>
                    <ReservationCheckCustomerInfo
                      handleChange={handleChange}
                      values={values}
                      errors={errors}
                      phoneError={phoneError}
                      setPhoneError={setPhoneError}
                      countryCode={countryCode}
                    />
                  </div>
                )
              ) : null}

              <div className='mt-3'>
                <OccasionSelectorButton
                  handleSelectButton={handleSelectOccasion}
                  selectedButton={selectedOccasion}
                />
              </div>

              <div className='mt-3'>
                <CustomerSpecialRequest
                  open={open}
                  setOpen={setOpen}
                  values={values}
                  handleChange={handleChange}
                />

                {error && (
                  <>
                    <ErrorBox title={error} />
                    <div className='mt-4 text-center text-primary' onClick={() => history.goBack()}>
                      {t('reschedule')}
                    </div>
                  </>
                )}
              </div>

              {intervals.length === 0 && hasProducts ? (
                <div className='mt-3'>
                  <EmptyActivity title={t('noSchedule')} />
                </div>
              ) : (
                <>
                  {requiredPerformance.includes(reservation.reservationType) ? (
                    <div className='position-relative'>
                      <div className='mt-4' style={{ marginBottom: '-1rem' }}>
                        {reservation.reservationType.toLowerCase() === 'group' && (
                          <>
                            <span className='fw-semibold text-primary font-tiny'>
                              {t('eventInformation')}
                            </span>
                            <div className='mt-4'>
                              <InputFormBorder
                                color='#757575'
                                name='eventName'
                                type='text'
                                onChange={handleChange}
                                value={values.eventName}
                                error={errors.eventName}
                                placeholder={t('event')}
                                label={t('eventName')}
                                border={'none'}
                                maxLength={200}
                              />
                            </div>
                          </>
                        )}
                        <p className='m-0 bold mt-4 text-primary'>
                          {reservation.reservationType.toLowerCase() === 'area'
                            ? t('arrivalTime')
                            : t('startTimeEvent')}
                        </p>
                        <div className='mt-3'>
                          <ProductPerformanceSelector
                            performances={intervals}
                            onSelect={setSelectedPerformance}
                            selectedPerformance={selectedPerformance}
                            language={language}
                            selectedDate={reservation.date}
                            loadingSchedule={loadingSchedule}
                          />
                        </div>
                      </div>
                      {errors.performance && errors.performance.length > 0 && (
                        <div
                          className='errorLabel mt-2 position-relative'
                          style={{ color: '#fff' }}
                        >
                          <span></span> {errors.performance}
                        </div>
                      )}
                    </div>
                  ) : null}
                </>
              )}
              {reservationInfo && (
                <>
                  {hasProducts && reservationInfo.remainingDepositAmount > 0 && (
                    <div className='font-1rem mt-4'>
                      <div className='bold text-primary'>{t('termsAndConditions')}</div>
                      <div className='mt-1'>
                        <span className='bold'>{t('paymentRequiredTitle')}</span>{' '}
                        {t('paymentRequiredText')}
                        <Money
                          value={reservationInfo.remainingDepositAmount}
                          symbol={currency.shortForm}
                          lowDecimals={true}
                          decimal={false}
                        />
                      </div>
                    </div>
                  )}

                  {reservationInfo.remainingAmount > 0 ? (
                    <div className={`row justify-content-center my-4`}>
                      <div className='col-4 pr-1'>
                        <SummaryBox title='Total' value={reservationInfo.totalAmount} />
                      </div>
                      <div className='col-4 px-2'>
                        <SummaryBox
                          title={t('deposit')}
                          value={reservationInfo.depositAmount}
                          subtitle={t('productsInfo.payUponConfirmation')}
                        />
                      </div>
                      <div className='col-4 pl-1'>
                        <SummaryBox
                          title='Balance'
                          value={reservationInfo.remainingAmount}
                          subtitle={t('productsInfo.payUponArrival')}
                        />
                      </div>
                    </div>
                  ) : null}
                </>
              )}
            </>
          )}
        </div>
      </ContentApp>

      <ContentBottom>
        <ButtonProccessing
          status={btnStatus}
          text={t('requestReservation')}
          size='large'
          className={`${styles.btn} mt-2`}
          type='submit'
          disabled={intervals.length === 0 && hasProducts}
          onClick={handleSubmit}
          arrow
          color='#000'
          backgroundColor='var(--color-primary)'
          iconColor='#000'
        />
      </ContentBottom>
      {platform && (
        <>
          <div className='text-secondary font-tiny pl-3 pr-3 pb-2'>
            {t('opentableTermsAndConditions.clickingRequestBooking')}{' '}
            <a
              href='https://www.opentable.com.mx/c/legal/terms-and-conditions/'
              className='text-primary'
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('opentableTermsAndConditions.termsOfUse')}
            </a>
            {t('opentableTermsAndConditions.andThe')}{' '}
            <a
              href='https://www.opentable.com.mx/c/legal/privacy-policy/'
              className='text-primary'
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('opentableTermsAndConditions.privacyPolicy')}
            </a>
            {t('opentableTermsAndConditions.openTable')}
          </div>

          <div className='text-center mb-3 mt-1 '>
            <span className='semi_bold mr-1 font-smaller'>Powered by&nbsp;</span>

            <img
              className={styles.containerImgLogoPlatform}
              src={externalPlaftormInfo?.logoUrl}
              alt='logo-powerred-by'
            />
          </div>
        </>
      )}
    </>
  );
};

export default ReservationCheck;
